import { FC } from "react";
import { AdditionalInformation, MainInformation } from "./Signature";

interface CodeToGenerateProps {
  mainInformation: MainInformation;
  additionalInformation: AdditionalInformation[];
}

const CodeToGenerate: FC<CodeToGenerateProps> = ({
  mainInformation,
  additionalInformation,
}) => {
  const franceData = additionalInformation?.find(
    (elem) => elem?.pays === "FRANCE"
  );
  const marocData = additionalInformation?.find(
    (elem) => elem?.pays === "MAROC"
  );
  const tunisieData = additionalInformation?.find(
    (elem) => elem?.pays === "TUNISIE"
  );
  const madagascarData = additionalInformation?.find(
    (elem) => elem?.pays === "MADAGASCAR"
  );

  const name = `${mainInformation?.prenom} ${mainInformation?.nom}`;

  return (
    <table style={{ width: "auto" }} id="mySignature">
      <tbody>
        <tr>
          <td style={{ width: "100%" }}>
            <table
              // cellPadding={0}
              // cellSpacing={0}
              // border={0}
              style={{
                fontSize: "11px",
                width: "100%",
                fontFamily: "arial, sans-serif",
                color: "#8E8E8E",
              }}
            >
              <tbody>
                <tr style={{ alignItems: "center" }}>
                  <td
                    style={{
                      width: "33.3333%",
                      borderRight: "1px solid #fca904",
                      color: "#8E8E8E",
                      minWidth: "200px",
                    }}
                  >
                    <h3 style={{ color: "#fa8910", margin: "10px" }}>{name}</h3>
                    <p style={{ margin: "10px" }}>{mainInformation?.mail}</p>
                  </td>
                  <td
                    style={{
                      width: "33.3333%",
                      textAlign: "center",
                      borderRight: "1px solid #fca904",
                      color: "#8E8E8E",
                      minWidth: "200px",
                    }}
                  >
                    <p>
                      <b>{mainInformation?.fonction}</b>
                    </p>
                    <br />
                  </td>
                  <td
                    style={{
                      minWidth: "200px",
                    }}
                  >
                    <div
                      style={{
                        width: "93%",
                        textAlign: "right",
                        marginLeft: "20px",
                      }}
                    >
                      <img
                        width={165}
                        src="https://api-suivirenta.outsourcia.fr/public/signatureImage/LOGO2.png"
                        alt="Une image"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            {/* FIN COL 1 */}
          </td>
        </tr>
        <tr>
          <td>
            <table
              // cellPadding={0}
              // cellSpacing={0}
              // border={0}
              style={{
                fontSize: "10px",
                fontFamily: "arial, sans-serif",
                color: "#8E8E8E",
              }}
            >
              <tbody>
                <tr>
                  {marocData && (
                    <td
                      style={{
                        verticalAlign: "top",
                        width: "310px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <table
                          style={{
                            fontSize: "10px",
                            width: "100%",
                            fontFamily: "arial, sans-serif",
                            color: "#8E8E8E",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                              // style={{ marginLeft: '10px' }}
                              >
                                <img
                                  src="https://api-suivirenta.outsourcia.fr/public/signatureImage/ma.png"
                                  alt="Téléphone"
                                  style={{ marginLeft: "5px" }}
                                />
                              </td>
                              <td>
                                <p
                                  style={{ margin: "5px 0", fontSize: "11px" }}
                                >
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/tel.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <b style={{ fontSize: 11 }}>
                                  {marocData?.fixe}
                                  <span>
                                    {" "}
                                    <img
                                      src="https://api-suivirenta.outsourcia.fr/public/signatureImage/portable.png"
                                      alt="Téléphone"
                                      style={{
                                        marginRight: "5px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                  </span>
                                  {marocData?.mobile}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <p style={{ margin: "-5px 0" }}>
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/geo.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <p style={{ margin: "-5px 0" }}>
                                  {marocData?.adresse}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#fa8910",
                                      marginLeft: "4px",
                                      marginRight: "2px",
                                    }}
                                  >
                                    |
                                  </span>
                                  {marocData?.code_postal}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  )}
                  {/* Copier Juste Cette TD Pour Une Novelle Numero Copier Le <td> en Bas */}
                  {franceData && (
                    <td
                      style={{
                        verticalAlign: "top",
                        width: "310px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <table
                          style={{
                            fontSize: "10px",
                            width: "100%",
                            fontFamily: "arial, sans-serif",
                            color: "#8E8E8E",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ marginLeft: "10px" }}>
                                <img
                                  src="https://api-suivirenta.outsourcia.fr/public/signatureImage/fr.png"
                                  alt="Téléphone"
                                  style={{ marginLeft: "5px" }}
                                />
                              </td>
                              <td>
                                <p
                                  style={{ margin: "5px 0", fontSize: "11px" }}
                                >
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/tel.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <b style={{ fontSize: 11 }}>
                                  {franceData?.fixe}
                                  <span>
                                    {" "}
                                    <img
                                      src="https://api-suivirenta.outsourcia.fr/public/signatureImage/portable.png"
                                      alt="Téléphone"
                                      style={{
                                        marginRight: "5px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                  </span>
                                  {franceData?.mobile}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <p style={{ margin: "-5px 0" }}>
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/geo.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <p style={{ margin: "-5px 0" }}>
                                  {franceData?.adresse}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#fa8910",
                                      marginLeft: "4px",
                                      marginRight: "2px",
                                    }}
                                  >
                                    |
                                  </span>
                                  {franceData?.code_postal}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  )}

                  {tunisieData && (
                    <td
                      style={{
                        verticalAlign: "top",
                        width: "310px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <table
                          style={{
                            fontSize: "10px",
                            width: "100%",
                            fontFamily: "arial, sans-serif",
                            color: "#8E8E8E",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ marginLeft: "10px" }}>
                                <img
                                  src="https://api-suivirenta.outsourcia.fr/public/signatureImage/tn.png"
                                  alt="Téléphone"
                                  style={{ marginLeft: "5px" }}
                                />
                              </td>
                              <td>
                                <p
                                  style={{ margin: "5px 0", fontSize: "11px" }}
                                >
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/tel.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <b style={{ fontSize: 11 }}>
                                  {tunisieData?.fixe}
                                  <span>
                                    {" "}
                                    <img
                                      src="https://api-suivirenta.outsourcia.fr/public/signatureImage/portable.png"
                                      alt="Téléphone"
                                      style={{
                                        marginRight: "5px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                  </span>
                                  {tunisieData?.mobile}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <p style={{ margin: "-5px 0" }}>
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/geo.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <p style={{ margin: "-5px 0" }}>
                                  {tunisieData?.adresse}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#fa8910",
                                      marginLeft: "4px",
                                      marginRight: "2px",
                                    }}
                                  >
                                    |
                                  </span>
                                  {tunisieData?.code_postal}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  )}

                  {madagascarData && (
                    <td
                      style={{
                        verticalAlign: "top",
                        width: "310px",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <table
                          style={{
                            fontSize: "10px",
                            width: "100%",
                            fontFamily: "arial, sans-serif",
                            color: "#8E8E8E",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ marginLeft: "10px" }}>
                                <img
                                  src="https://api-suivirenta.outsourcia.fr/public/signatureImage/md.png"
                                  alt="Téléphone"
                                  style={{ marginLeft: "5px" }}
                                />
                              </td>
                              <td>
                                <p
                                  style={{ margin: "5px 0", fontSize: "11px" }}
                                >
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/tel.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <b style={{ fontSize: 11 }}>
                                  {madagascarData?.fixe}
                                  <span>
                                    {" "}
                                    <img
                                      src="https://api-suivirenta.outsourcia.fr/public/signatureImage/portable.png"
                                      alt="Téléphone"
                                      style={{
                                        marginRight: "5px",
                                        marginLeft: "10px",
                                      }}
                                    />
                                  </span>
                                  {madagascarData?.mobile}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                <p style={{ margin: "-5px 0" }}>
                                  <img
                                    src="https://api-suivirenta.outsourcia.fr/public/signatureImage/geo.png"
                                    alt="Téléphone"
                                    style={{
                                      marginRight: "5px",
                                      marginLeft: "10px",
                                    }}
                                  />
                                </p>
                              </td>
                              <td style={{ textAlign: "left" }} colSpan={3}>
                                <p style={{ margin: "-5px 0" }}>
                                  {madagascarData?.adresse}
                                  <span
                                    style={{
                                      fontSize: "15px",
                                      color: "#fa8910",
                                      marginLeft: "4px",
                                      marginRight: "2px",
                                    }}
                                  >
                                    |
                                  </span>
                                  {madagascarData?.code_postal}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  )}

                  {/* Fin Du Copie */}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        {/* FIN Ligne 2 */}
        <tr>
          <td>
            <table
              // cellPadding={0}
              // cellSpacing={0}
              // border={0}
              style={{
                fontSize: "10px",
                width: "100%",
                fontFamily: "arial, sans-serif",
                color: "#8E8E8E",
                marginTop: "3px"
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      width: "40 %",
                      textAlign: "left",
                      color: "#585858",
                      marginLeft: "10px",
                    }}
                  >
                    <a href="https://www.outsourcia.com">
                      <img
                        style={{ marginLeft: "10px" }}
                        src="https://api-suivirenta.outsourcia.fr/public/signatureImage/site.png"
                      />
                    </a>
                  </td>
                  <td
                    style={{
                      marginTop: "5px",
                      marginInlineEnd: "20px",
                      color: "#585858",
                      textAlign: "center",
                    }}
                  >
                    <p style={{ margin: "5px 0" }}>
                      <a
                        style={{ textDecoration: "none", marginRight: "5px" }}
                        href="https://twitter.com/Outsourcia"
                      >
                        <img
                          src="https://api-suivirenta.outsourcia.fr/public/signatureImage/x.png"
                          alt="Téléphone"
                        />
                      </a>
                      <a
                        style={{ textDecoration: "none", marginRight: "5px" }}
                        href="https://www.linkedin.com/company/groupe-outsourcia/"
                      >
                        <img
                          src="https://api-suivirenta.outsourcia.fr/public/signatureImage/in.png"
                          alt="Téléphone"
                        />
                      </a>
                      <a
                        style={{ textDecoration: "none", marginRight: "5px" }}
                        href="https://www.facebook.com/Outsourcia"
                      >
                        <img
                          src="https://api-suivirenta.outsourcia.fr/public/signatureImage/f.png"
                          alt="Téléphone"
                        />
                      </a>
                      <a
                        style={{ textDecoration: "none", marginRight: "5px" }}
                        href="https://www.instagram.com/outsourcia_maroc/"
                      >
                        <img
                          src="https://api-suivirenta.outsourcia.fr/public/signatureImage/insta.png"
                          alt="Téléphone"
                        />
                      </a>
                    </p>
                  </td>
                  <td>
                    <div style={{ width: "100%", textAlign: "right" }}>
                      <a href="https://www.youtube.com/watch?v=eXqpfZY_3nk">
                        <img src="https://api-suivirenta.outsourcia.fr/public/signatureImage/video2.png" />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        {mainInformation?.consentement && (
          <tr>
            <td style={{ maxWidth: "600px" }}>
              <p
                style={{
                  fontFamily: "Verdana, Geneva, sans-serif",
                  color: "#8E8E8E",
                  fontSize: "10px",
                }}
              >
                ---
                <br />
                Le contenu de cet e-mail est confidentiel et destiné au
                destinataire spécifié dans le message uniquement. Il est
                strictement interdit de partager toute partie de ce message avec
                un tiers, sans le consentement écrit de l'expéditeur.
                <br />
                Si vous avez reçu ce message par erreur, veuillez répondre à ce
                message et suivre sa suppression, afin que nous puissions nous
                assurer qu'une telle erreur ne se reproduise plus à l'avenir.
                <br />
                ---
              </p>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default CodeToGenerate;
